import { Dialog as MUIDialog, styled } from '@mui/material'

const Dialog = styled(MUIDialog)(() => ({
  '.MuiPaper-root': {
    backgroundColor: 'rgb(231,239, 244)',
  },
}))

export default Dialog
